
import XHeader from 'vux/src/components/x-header/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'

import {listOneImg} from './js/gift';

export default {
data(){
return{
list:[],
shoppingcard:''
}
},
components: {
XHeader,Grid, GridItem
},
methods:{
ListClick(item){
this.$router.push({path:'integralMallList',query:{openid:this.$route.query.openid,personInfoId:this.$route.query.personInfoId,Mypoints:this.$route.query.Mypoints,headeTxt:item.title,detail:item.txt,xm:this.$route.query.xm,sfzh:this.$route.query.sfzh}});
}
},
mounted(){

this.shoppingcard = window.localStorage.getItem('card');
for(let i =0;i<listOneImg.length;i++){
/*this.list = listOneImg;*/
if(this.shoppingcard == '1'){
if(listOneImg[i].txt =='红旗'||listOneImg[i].txt =='京东'||listOneImg[i].txt =='伊藤'){
this.list.push(listOneImg[i]);
}
}else if(this.shoppingcard == '2' ||this.shoppingcard == '3'){
if(listOneImg[i].txt =='红旗'){
this.list.push(listOneImg[i]);
}
}




}

}
}



// WEBPACK FOOTER //
// ./src/project/integralMallProject/integralMallListOne.vue